<template>
  <a-range-picker
    v-bind="instance"
    format="YYYY-MM-DD"
    show-time
    v-model="defaultValue"
    @change="onChange"
    class="isW"
  ></a-range-picker>
</template>

<script>
export default {
  props: {
    instance: Object // 配置
  },
  data() {
    return {
      defaultValue: null
    }
  },
  watch: {
    instance: {
      handler(nVal) {
        Object.assign(this, { ...nVal }) // 把传入的参数，融合到this中
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onChange(k, v) {
      console.log(k, v)
      this.$emit('change', v)
    }
  }
}
</script>
<style lang="scss" scoped>
.isW {
  width: 100% !important;
}
</style>